// eslint-disable-next-line no-unused-vars
import React from 'react'
import { ThemeProvider } from 'styled-components'
import theme, { GlobalStyle } from './src/theme'
import './src/theme/icons'
import Layout from './src/components/Layout'

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.state && location.state.preventScroll === true) {
    return false
  }

  if (location.hash) {
    window.history.scrollRestoration = 'auto'
    return true
  }

  const currentPosition = getSavedScrollPosition(location, location.key)
  const top = currentPosition ? currentPosition[1] : 0

  if (top === window.pageYOffset) {
    return false
  }

  window.history.scrollRestoration = 'manual'

  window.requestAnimationFrame(() => {
    setTimeout(() => {
      try {
        window.scrollTo({ top, behavior: 'instant' })
      } catch (e) {
        window.scrollTo(top)
      }
      // exit animation duration, probably
    }, 400)
  })

  return false
}

export const wrapPageElement = ({ element }) => {
  return (
    <>
      <GlobalStyle theme={theme} />
      <ThemeProvider theme={theme}>
        <Layout>{element}</Layout>
      </ThemeProvider>
    </>
  )
}
